import React, { useContext } from 'react';
import { Grid } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { decryptURL } from 'utils/functions';
import { GridContext } from 'contexts/GridContext';
import { DropsContext } from 'contexts/DropsContext';
import VirtualDrop from 'components/VirtualDrop';
import Container from 'components/Container';
import InputMask from 'components/InputMask';
import Button from 'components/Button';
import Header from 'components/Header';
import Input from 'components/Input';

const Edit = () => {
  const navigate = useNavigate();
  const { hash } = useParams();
  const params = decryptURL(hash);
  const defaultValues = {
    id: params?.id,
    numero: params?.numero || '',
    identificacao: params?.identificacao || '',
    produto_id: params?.produto_id || null,
  };
  const { control, handleSubmit } = useForm({ defaultValues });
  const { postGrid, postLoading } = useContext(GridContext);
  const { drops } = useContext(DropsContext);

  const onSubmit = (data = {}) =>
    postGrid({
      data: { data, rotina: 'Embalagem' },
      cb: () => navigate(-1),
    });

  return (
    <Container>
      <Header titulo={`Editar Embalagem ${params?.id || ''}`} />
      <Grid container spacing={2}>
        <Grid item xs={12} />
        <Grid item xs={12} sm={6}>
          <InputMask name="numero" control={control} label="Número" />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Input name="identificacao" control={control} label="Identificação" />
        </Grid>
        <Grid item xs={12}>
          <VirtualDrop
            name="produto_id"
            control={control}
            label="Tipo da Embalagem"
            options={drops?.Produto}
          />
        </Grid>
        <Grid item xs={12} textAlign="center">
          <Button
            variant="contained"
            color="primary"
            loading={postLoading}
            onClick={handleSubmit(onSubmit)}
          >
            Salvar
          </Button>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Edit;
